import axios from "axios";


var Announcement = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },

    findAnnouncement: function (params) {
        return axios.get(
            Apollo.resolveApiUrl("~/PlanAnnouncement/?ln=" + params.ln));
    },
    optOutOfAnnouncement: function (params) {
        return axios.post(Apollo.resolveApiUrl("~/PlanAnnouncement/"), params);
    }

};

export default Announcement;



// WEBPACK FOOTER //
// ./src/models/Announcement.js